import { render, staticRenderFns } from "./ThePrivacy.vue?vue&type=template&id=0c24e6ea"
import script from "./ThePrivacy.vue?vue&type=script&lang=js"
export * from "./ThePrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports